<h1 class="h1-assistenza" mat-dialog-title>{{ title }}</h1>
<div mat-dialog-content>
  <p [innerHTML]="confirmMessage"></p>
  <a class="assistenza" mat-raised-button color="primary" [href]="'mailto:'">Contatta l'assistenza con il dettaglio</a>
</div>
<div mat-dialog-actions class="div-ok">
  <button mat-raised-button (click)="dialogRef.close(false)">Ok</button>
</div>
